module.exports = __webpack_public_path__ + "img/15-1_08.e8378923.jpg";